import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";

export interface HeaderState {
    hamburgerMenu:{open:boolean}
}

const initialState: HeaderState = {
  hamburgerMenu: {
    open: false,
  },
};

export const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    headerHamburgerMenuAction: (state, action: PayloadAction<boolean>) => {
      state.hamburgerMenu.open = action.payload;
    },
  },
});

export const {
    headerHamburgerMenuAction
} = headerSlice.actions;

export const header = (state: RootState) => state.headerState;

export default headerSlice.reducer;
